module.exports = parseOptions;

var _require = require("deprecation"),
    Deprecation = _require.Deprecation;

var _require2 = require("universal-user-agent"),
    getUserAgent = _require2.getUserAgent;

var once = require("once");

var pkg = require("../package.json");

var deprecateOptionsTimeout = once(function (log, deprecation) {
  return log.warn(deprecation);
});
var deprecateOptionsAgent = once(function (log, deprecation) {
  return log.warn(deprecation);
});
var deprecateOptionsHeaders = once(function (log, deprecation) {
  return log.warn(deprecation);
});

function parseOptions(options, log, hook) {
  if (options.headers) {
    options.headers = Object.keys(options.headers).reduce(function (newObj, key) {
      newObj[key.toLowerCase()] = options.headers[key];
      return newObj;
    }, {});
  }

  var clientDefaults = {
    headers: options.headers || {},
    request: options.request || {},
    mediaType: {
      previews: [],
      format: ""
    }
  };

  if (options.baseUrl) {
    clientDefaults.baseUrl = options.baseUrl;
  }

  if (options.userAgent) {
    clientDefaults.headers["user-agent"] = options.userAgent;
  }

  if (options.previews) {
    clientDefaults.mediaType.previews = options.previews;
  }

  if (options.timeZone) {
    clientDefaults.headers["time-zone"] = options.timeZone;
  }

  if (options.timeout) {
    deprecateOptionsTimeout(log, new Deprecation("[@octokit/rest] new Octokit({timeout}) is deprecated. Use {request: {timeout}} instead. See https://github.com/octokit/request.js#request"));
    clientDefaults.request.timeout = options.timeout;
  }

  if (options.agent) {
    deprecateOptionsAgent(log, new Deprecation("[@octokit/rest] new Octokit({agent}) is deprecated. Use {request: {agent}} instead. See https://github.com/octokit/request.js#request"));
    clientDefaults.request.agent = options.agent;
  }

  if (options.headers) {
    deprecateOptionsHeaders(log, new Deprecation("[@octokit/rest] new Octokit({headers}) is deprecated. Use {userAgent, previews} instead. See https://github.com/octokit/request.js#request"));
  }

  var userAgentOption = clientDefaults.headers["user-agent"];
  var defaultUserAgent = "octokit.js/".concat(pkg.version, " ").concat(getUserAgent());
  clientDefaults.headers["user-agent"] = [userAgentOption, defaultUserAgent].filter(Boolean).join(" ");
  clientDefaults.request.hook = hook.bind(null, "request");
  return clientDefaults;
}